<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <div>
                        <img src="@/assets/images/charging-cancel.png" alt="" />
                    </div>
                    <span>보내는 분과 받는 분이 동일하여 구매로 간주되며<br>선물하기 혜택은 적용되지 않습니다.</span>
                </div>
            </div>
            <div class="button-wrap">
              <button class="button-bg-gray border-left-round" @click="modalClose(false)">취소</button>
              <button class="button-bg-yellow border-right-round" @click="modalClose(true)">확인</button>
            </div>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'phoneNumberConfirmPopup',
    components: {BottomButton},
    data() {
        return  {
        }
    },
    methods : {
      /**
       * 선물받는분 핸드폰 번호 확인 모달 close
       * @param {boolean} confirmFlag 선물받는분의 핸드폰 번호 확인 OK 여부
       */
      modalClose(confirmFlag) {
        this.$emit('giftToMeConfirm', confirmFlag);
      }
    }
}
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/cards/cancelChargingPopup.scss';
</style>